export const placementActivityRoutes = [
  {
    path: '/placement-activity',
    name: 'placement-activity',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "PlacementActivity" */ './PlacementActivity.vue')
  }
];
